import { REGION } from '../app/app.constants';
import store from './store';

export class RegionHelper {
    public static getRegion(): string {
        return store.getState().app.appConfig.REGION;
    }

    public static isEU(): boolean {
        return this.getRegion() === REGION.EU;
    }
    public static isJP(): boolean {
        return this.getRegion() === REGION.JP;
    }
    public static isAP(): boolean {
        return this.getRegion() === REGION.AP;
    }
}
